import React from 'react';

type ReportFilterStringProps = {
  type: string;
  name: string;
  onChange: (value: string) => void;
};

export default function ReportFilterString({
  type,
  name,
  onChange,
}: ReportFilterStringProps) {
  return (
    <input
      type={type || 'text'}
      className='form-control'
      id={name}
      name={name}
      aria-describedby={name}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}
